module.exports = __webpack_public_path__ + "static/media/menu-4.1643a4d7.jpg";